import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Browser from '@wetransfer/concorde-browser';

import { CSSTransition } from 'react-transition-group';

import { AppConfig } from '../../core-bundle/config/app-config';

const BASE_CLASS_NAME = 'actionbar';

export default class ActionBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { hidden: props.hidden };
  }

  hide(callback) {
    this.setState({ hidden: true });

    if (callback) {
      this.animationNotificationTimeout = setTimeout(
        callback,
        AppConfig.notification.animation_duration
      );
    }

    return this;
  }

  show() {
    this.setState({ hidden: true });

    return this;
  }

  componentWillUnmount() {
    clearTimeout(this.animationNotificationTimeout);
  }

  render() {
    const { hidden, children, text, html, className } = this.props;

    const actionbarClassName = classnames(BASE_CLASS_NAME, className, {
      [`${BASE_CLASS_NAME}--hidden`]: hidden,
    });

    const elements = (
      <div className={`${BASE_CLASS_NAME}__elements`}>{children}</div>
    );
    const textComponent = html ? (
      <div
        className={`${BASE_CLASS_NAME}__text`}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    ) : (
      <div className={`${BASE_CLASS_NAME}__text`}>{text}</div>
    );
    const content = Browser.isMobile ? (
      <>
        {textComponent}
        {elements}
      </>
    ) : (
      <>
        {elements}
        {textComponent}
      </>
    );

    return (
      <CSSTransition
        in={!hidden}
        timeout={300}
        classNames={{
          enter: BASE_CLASS_NAME, //add actionbar--hidden to activate transition on enter. bug on iphone
          enterDone: BASE_CLASS_NAME,
          exit: `${BASE_CLASS_NAME} ${BASE_CLASS_NAME}--hidden`,
        }}
        unmountOnExit
      >
        <div className={actionbarClassName}>{content}</div>
      </CSSTransition>
    );
  }
}

ActionBar.propTypes = {
  text: PropTypes.any,
  html: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  hidden: PropTypes.bool,
};
